<template>
  <el-card shadow="never" class="finance-query-panel">
    <div class="finance-page-heading">
      <div>
        <div class="finance-page-title">{{ title }}</div>
        <div class="finance-page-desc">{{ description }}</div>
      </div>
      <slot name="actions" />
    </div>
    <el-form :inline="true" class="finance-query-form">
      <el-form-item label="统计年份">
        <el-date-picker
          :value="reportYear"
          type="year"
          value-format="yyyy"
          :clearable="false"
          style="width: 140px"
          @input="$emit('update:reportYear', $event)"
        />
      </el-form-item>
      <el-form-item label="签约年份">
        <el-select :value="queryParams.contractYear" clearable placeholder="全部年份" style="width: 140px" @input="updateQuery('contractYear', $event)">
          <el-option v-for="year in dashboard.contractYearOptions" :key="year" :label="`${year}年`" :value="year" />
        </el-select>
      </el-form-item>
      <el-form-item label="部门">
        <el-select :value="queryParams.departmentName" clearable placeholder="全部部门" style="width: 170px" @input="updateQuery('departmentName', $event)">
          <el-option v-for="department in dashboard.departmentOptions" :key="department" :label="department" :value="department" />
        </el-select>
      </el-form-item>
      <el-form-item label="产品大类">
        <el-select :value="queryParams.productCategory" clearable placeholder="全部大类" style="width: 170px" @input="updateQuery('productCategory', $event)">
          <el-option v-for="category in dashboard.productCategoryOptions" :key="category" :label="category" :value="category" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="showKeyword" label="关键词">
        <el-input
          :value="queryParams.keyword"
          clearable
          placeholder="合同编号/名称/客户"
          style="width: 220px"
          @input="updateQuery('keyword', $event)"
          @keyup.enter.native="$emit('query')"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" @click="$emit('query')">查询</el-button>
        <el-button icon="el-icon-refresh" @click="$emit('reset')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'FinanceQueryPanel',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    reportYear: { type: String, required: true },
    queryParams: { type: Object, required: true },
    dashboard: { type: Object, required: true },
    loading: Boolean,
    showKeyword: { type: Boolean, default: true }
  },
  methods: {
    updateQuery (field, value) {
      this.$emit('update:queryParams', Object.assign({}, this.queryParams, { [field]: value }))
    }
  }
}
</script>

<style lang="scss" scoped>
.finance-page-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}
.finance-page-title {
  color: #1f2d3d;
  font-size: 21px;
  font-weight: 600;
}
.finance-page-desc {
  margin-top: 8px;
  color: #8492a6;
  font-size: 13px;
  line-height: 1.6;
}
.finance-query-form {
  margin-top: 20px;
}
.finance-query-form ::v-deep .el-form-item {
  margin-bottom: 4px;
}
@media (max-width: 768px) {
  .finance-page-heading { flex-direction: column; }
}
</style>
